<canvas *ngIf="resultToChart"
        baseChart
        [class.empty]="empty"
        [datasets]="resultToChart"
        [labels]="lineChartLabels"
        [options]="config.lineChartOptions"
        [colors]="colors"
        [chartType]="config.lineChartType"></canvas>
<cc-empty-chart
  *ngIf="empty"
  [empty]="empty"
></cc-empty-chart>
